import { useState } from 'react';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { useAuth } from '@/lib/auth';
import { Lightbulb, Plus, FolderOpen, ShieldCheck } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { CreateIdeaDialog } from '@/components/ideas/CreateIdeaDialog';
import { MyIdeasList } from '@/components/ideas/MyIdeasList';
import { IdeaAdminPanel } from '@/components/ideas/IdeaAdminPanel';

export default function IdeaBox() {
    const { user } = useAuth();
    const isAdmin = ['admin_full', 'admin'].includes(user?.role);
    const [createOpen, setCreateOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [tab, setTab] = useState(isAdmin ? 'admin' : 'mine');

    const onCreated = () => { setRefreshKey((k) => k + 1); setTab('mine'); };

    return (
        <DashboardLayout>
            <div className="space-y-6" data-testid="idea-box-page">
                {/* En-tête */}
                <div className="overflow-hidden rounded-3xl bg-[#0B1F3B] px-5 py-6 text-white sm:px-6 sm:py-7">
                    <div className="flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
                        <div>
                            <p className="flex items-center gap-2 text-amber-300">
                                <Lightbulb className="h-5 w-5" />
                                <span className="text-sm font-semibold uppercase tracking-wide">Boîte à Idées Valnexo</span>
                            </p>
                            <h1 className="mt-2 text-2xl font-black sm:text-3xl">Faites avancer Valnexo</h1>
                            <p className="mt-1 max-w-xl text-sm text-slate-300/85">
                                Un espace d'amélioration continue : proposez vos idées d'innovation et d’optimisation. Les meilleures idées seront étudiées par la direction.
                            </p>
                        </div>
                        <button onClick={() => setCreateOpen(true)} data-testid="open-create-idea"
                            className="flex w-full items-center justify-center gap-2 rounded-2xl bg-amber-500 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-amber-500/20 transition-colors hover:bg-amber-600 sm:w-auto">
                            <Plus className="h-4 w-4" /> Déposer une idée
                        </button>
                    </div>
                </div>

                {isAdmin ? (
                    <Tabs value={tab} onValueChange={setTab}>
                        <TabsList data-testid="idea-tabs">
                            <TabsTrigger value="admin" data-testid="idea-tab-admin"><ShieldCheck className="mr-1.5 h-4 w-4" /> Administration</TabsTrigger>
                            <TabsTrigger value="mine" data-testid="idea-tab-mine"><FolderOpen className="mr-1.5 h-4 w-4" /> Mes idées</TabsTrigger>
                        </TabsList>
                        <TabsContent value="admin" className="mt-5"><IdeaAdminPanel refreshKey={refreshKey} /></TabsContent>
                        <TabsContent value="mine" className="mt-5"><MyIdeasList refreshKey={refreshKey} /></TabsContent>
                    </Tabs>
                ) : (
                    <MyIdeasList refreshKey={refreshKey} />
                )}
            </div>

            <CreateIdeaDialog open={createOpen} onOpenChange={setCreateOpen} onCreated={onCreated} />
        </DashboardLayout>
    );
}
